import ImporterMainLayout from "@/src/components/template/Layout/importer/ImporterMainLayout";
import CompanyManagement from "@/src/components/organism/CompanyManagement";
import { useGetExportersQuery } from "@/src/store/apis/corporate/company";
import { isUndefined } from "@/src/utils/is";
import { useTranslation } from "react-i18next";

const ImporterCompanyInformationManagement = () => {
  const { t } = useTranslation();

  const { companyName } = useGetExportersQuery(undefined, {
    refetchOnMountOrArgChange: true,
    selectFromResult: ({ currentData, isError, isFetching }) => {
      const isUnstable = isError || isFetching || isUndefined(currentData);
      const isStable = !isUnstable;

      return {
        companyName: isStable ? currentData.basicInformation.companyName : "-",
      };
    },
  });

  return (
    <ImporterMainLayout
      breadcrumb={[
        t("sideNav:workspaceSettings"),
        t("sideNav:companyInformation"),
      ]}
      pageTitle={companyName}
    >
      <CompanyManagement role="IMPORTER" />
    </ImporterMainLayout>
  );
};

export default ImporterCompanyInformationManagement;
